import {
    CandleLightingEvent,
    HavdalahEvent,
    HDate,
    HebrewCalendar,
    Location,
    Molad,
    MoladEvent,
    OmerEvent,
    ParshaEvent,
    RoshChodeshEvent,
    RoshHashanaEvent,
    Zmanim
} from "@hebcal/core"
import '@hebcal/locales'
import {SolarCalc} from '@hebcal/solar-calc'

// HEBCAL FUNCTIONS

export default class Hebcal {
    DAYArray = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"]

    HEBCAL = []

    ORG = null

    LAT = null

    LON = null

    NOW = new Date()

    constructor(org = null, now = new Date(), lat = "48.8534", lon = "2.3488") {
        this.ORG = org
        this.NOW = now
        if (org) {
            this.LAT = org.lat
            this.LON = org.long
        } else {
            this.LAT = lat
            this.LON = lon
        }

    }

    generateHebCal(startDate = this.NOW) {
        const org = this.ORG

        var data = []

        var dateStart = new Date(startDate)
        dateStart.setDate(dateStart.getDate() - 10)

        var dateEnd = new Date(startDate)
        dateEnd.setDate(dateEnd.getDate() + 30)

        const options = {
            start: dateStart,
            end: dateEnd,
            isHebrewYear: false,
            candlelighting: true,
            //locale: "fr",
            location: new Location(parseFloat(this.LAT), parseFloat(this.LON)),
            sedrot: true,
            omer: true,
            noModern: true,
            shabbatMevarchim: true,
            molad: true,
            il: org.israel ? true : false,

        }

        const events = HebrewCalendar.calendar(options);

        //console.log("HEBCAL events",events)

        var data2 = {
            hdate: events[0].getDate(),
            date: events[0].getDate().greg(),
            desc: []
        }
        var time = events[0].getDate().greg().getTime()

        var preventree = false

        for (const ev of events) {
            const hd = ev.getDate();
            const date = hd.greg();

            if (time != date.getTime()) {
                time = date.getTime()

                data.push(data2)
                data2 = {
                    hdate: hd,
                    date: date,
                    desc: []
                }
            }

            data2.desc.push(ev.getDesc())

            if (ev instanceof OmerEvent) {
                data2.omer = ev.omer
            }

            if (ev.getDesc().includes("Rosh Hashana") && !ev.getDesc().includes("Erev")) {
                data2.yomtov = true
                data2.yomtovType = "ROSH_HASHANA"
            }

            if (ev instanceof MoladEvent) {
                //CHABBAT MEVARHIM
                //console.log("MEVARHIM",ev)
                data2.mevarhim = true
                data2.mevarhimMonth = ev.getDesc().replace("Molad", '').split(" ").slice(0, -1).join(" ").trim()
                data2.molad = ev.molad
            }


            if (ev instanceof RoshChodeshEvent) {
                //ROSH HODESH
                //console.log("ROSH HODESH",ev)
                data2.roshHodesh = true
                data2.roshHodeshMonth = ev.getDesc().replace("Rosh Chodesh ", '').trim()
            }

            if (ev instanceof ParshaEvent) {
                data2.parasha = ev.parsha.join("-")
            }

            if (ev instanceof HavdalahEvent) {
                preventree = false
                switch (org.zmanimShitat) {

                    case "HABBAD.ORG":
                        var solarCalc = new SolarCalc(new Date(ev.eventTime), parseFloat(org.lat), parseFloat(org.long));
                        var sun = solarCalc.sun;
                        data2.sortieShabbat = sun.timeAtAngle(8.5, false)
                        break;
                    default:
                        data2.sortieShabbat = new Date(ev.eventTime)
                }
            }

            if (ev instanceof CandleLightingEvent) {
                var dateentree = null

                switch (org.zmanimShitat) {
                    case "HABBAD.ORG":
                        var solarCalc = new SolarCalc(new Date(ev.eventTime), parseFloat(org.lat), parseFloat(org.long));
                        var sun = solarCalc.sun;
                        dateentree = sun.timeAtAngle(0.833, false)
                        if (org.israel) {
                            dateentree = new Date(dateentree.getTime() - 22 * 60000);
                        } else {
                            dateentree = new Date(dateentree.getTime() - 18 * 60000);
                        }
                        break;
                    default:
                        dateentree = new Date(ev.eventTime)
                }

                if (preventree && !data2.yomtov) {
                    data2.sortieShabbat = dateentree
                }

                preventree = true
                data2.entreeShabbat = dateentree
            }

            //console.log(date.toLocaleDateString(), ev.render(), hd.toString(),ev.getDesc());

        }

        this.HEBCAL = data

        //console.log("HEBCAL",HEBCAL)
    }

    getNextParasha(date) {
        date.setHours(0, 0, 0, 0);
        for (const item of this.HEBCAL) {
            if (date.getTime() <= item.date.getTime() && item.parasha != null) {
                return item.parasha
            }
        }
    }

    getNextEntreeShabbat(date) {
        date = new Date(date)
        date.setHours(0, 0, 0, 0);

        if (date.getDay() == 6)//SAMEDI
        {
            date.setDate(date.getDate() - 1)
        }

        for (const item of this.HEBCAL) {
            if (date.getTime() <= item.date.getTime() && item.entreeShabbat != null) {
                return item.entreeShabbat
            }
        }
    }

    getNextSortieShabbat(date) {
        date = new Date(date)
        date.setHours(0, 0, 0, 0);
        for (const item of this.HEBCAL) {
            if (date.getTime() <= item.date.getTime() && item.sortieShabbat != null) {
                return item.sortieShabbat
            }
        }

        return "error"
    }

    getDateNowFromZmanV2(date=this.NOW) {

        if(date.getHours()>=23){
            var newdate = new Date(date)
            newdate.setDate(newdate.getDate() + 1);
            return newdate
        }

        return this.getDateNowFromZman(date)
    }

    getDateNowFromZman(date = this.NOW) {
        const zmanim = new Zmanim(new Date(date), parseFloat(this.LAT), parseFloat(this.LON))

        if (Date.parse(date) > zmanim.tzeit(7.083).getTime()) {
            var newdate = new Date(date)
            newdate.setDate(newdate.getDate() + 1);
            return newdate
        }

        return date
    }

    getHebrewDate() {
        var date = this.getDateNowFromZman(new Date())

        var hdate = new HDate(date)

        return this.DAYArray[date.getDay()] + " " + hdate.getDate() + " " + hdate.getMonthName() + " " + hdate.getFullYear()
    }

    hdate(now = new Date()) {
        return new HDate(now)
    }

    getHebreuYear(now = new Date()) {
        return new HDate(now).getFullYear()
    }

    getHazkara(nichmat, anneeHE) {

        const nowHE = new HDate(this.getDateNowFromZman())

        var hazkara = new HDate(nichmat.jourHE, nichmat.moisHE, anneeHE)


        //CHECHVAN 30/29
        if (nichmat.jourHE == 30 && nichmat.moisHE == "Cheshvan" && HDate.longCheshvan(anneeHE) == false) {
            hazkara = new HDate(29, nichmat.moisHE, anneeHE)
        }

        //KISLEV 30/29
        if (nichmat.jourHE == 30 && nichmat.moisHE == "Kislev" && HDate.shortKislev(anneeHE) == true) {
            hazkara = new HDate(29, nichmat.moisHE, anneeHE)
        }


        if (hazkara.getFullYear() == nowHE.getFullYear()) {
            if (
                (hazkara.getTishreiMonth() == nowHE.getTishreiMonth() && hazkara.getDate() < nowHE.getDate())
                || hazkara.getTishreiMonth() < nowHE.getTishreiMonth()
            ) {
                return this.getHazkara(nichmat, anneeHE + 1)
            }
        }


        return {
            jourHaz: hazkara.getDate(),
            moisHaz: hazkara.getMonthName(),
            anneeHaz: hazkara.getFullYear(),
            greg: hazkara.greg()
        }
    }


    getDiffHDate(item) {
        const nowHE = new HDate(this.getDateNowFromZman())
        const hazkaraHE = new HDate(item.jourHaz, item.moisHaz, item.anneeHaz)

        return hazkaraHE.deltaDays(nowHE)
    }

    getGregDate(item) {
        const hdate = new HDate(item.jourHaz, item.moisHaz, item.anneeHaz)
        return hdate.greg()
    }


    getDateGematria(item) {
        var dateHE = new HDate(item.jourHE, item.moisHE, item.anneeHE)

        return dateHE.renderGematriya()
    }

    getHebCalByDate(date) {
        date = ('0' + date.getDate()).slice(-2) + "/" + ('0' + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear()

        for (var e of this.HEBCAL) {
            const date2 = ('0' + e.date.getDate()).slice(-2) + "/" + ('0' + (e.date.getMonth() + 1)).slice(-2) + "/" + e.date.getFullYear()
            if (date2 == date) {

                return e
            }
        }

        return false
    }

    getVariableZman(type, date) {
        const config = this.ORG

        date = new Date(date)
        date.setHours(0, 0, 0, 0);

        switch (config.zmanimShitat) {
            case "HABBAD.ORG":
                return this.getVariableZmanHabbad(type, date)
            default:
                return this.getVariableZmanDefault(type, date)
        }

    }

//CALLJ
    getVariableZmanDefault(type, date) {

        const zmanim = new Zmanim(new Date(date), parseFloat(this.LAT), parseFloat(this.LON))
        switch (type) {
            case "NETS":
                return zmanim.neitzHaChama()
            case "HATSOT":
                return zmanim.chatzot()
            case "PLAG":
                return zmanim.plagHaMincha()
            case "CHKIAH":
                return zmanim.shkiah()
            case "TSET":
                return zmanim.tzeit(7.083)
            case "ENTREE_CHABBAT":
                return this.getHebCalByDate(date).entreeShabbat
            case "SORTIE_CHABBAT":
                return this.getHebCalByDate(date).sortieShabbat
        }

        return null
    }

//HABAD.ORG
    getVariableZmanHabbad(type, date) {

        const zmanim = new Zmanim(new Date(date), parseFloat(this.LAT), parseFloat(this.LON))

        var solarCalc = new SolarCalc(new Date(date), parseFloat(this.LAT), parseFloat(this.LON));
        var sun = solarCalc.sun;

        const netshamiti = sun.timeAtAngle(1.583, true)

        const shkiahamiti = sun.timeAtAngle(1.583, false)

        const shaazmanit = (shkiahamiti - netshamiti) / 1000 / 60 / 12

        const hatsotJour = new Date(netshamiti.getTime() + (6 * shaazmanit) * 60000);

        const hatsotNuit = new Date(hatsotJour.getTime() + (12 * 60) * 60000);

        switch (type) {
            case "NETS":
                return zmanim.neitzHaChama()
            case "HATSOT":
                return hatsotJour
            case "PLAG":
                return new Date(shkiahamiti.getTime() - (1.25 * shaazmanit) * 60000)
            case "CHKIAH":
                return sun.timeAtAngle(0.833, false)
            case "TSET":
                return sun.timeAtAngle(6.83, false)
            case "ENTREE_CHABBAT":
                return this.getHebCalByDate(date).entreeShabbat
            case "SORTIE_CHABBAT":
                return this.getHebCalByDate(date).sortieShabbat
        }

        return null
    }

    getZmanimDay(date = new Date()) {
        var nextFound = false

        var data = null

        switch (this.ORG.zmanimShitat) {

            case "HABBAD.ORG":
                data = this.getZmanimHabad(date)
                break;
            default:
                data = this.getZmanimDefault(date)
                break;
        }


        data.sort((a, b) => {
            if (a == b) {
                return 0
            }
            return a < b ? -1 : 1
        })

        var dataFinal = []

        for (var item of data) {
            if (!nextFound && item.time > new Date()) {
                nextFound = true
                item.next = true
            }
            item.time = Zmanim.roundTime(item.time)
            dataFinal.push(item)
        }

        return data
    }


    isOmer() {
        var hebcal = this.getHebCalByDate(new Date())

        if (hebcal.omer) {
            return true
        }
        return false
    }


    needMolad() {
        var hebcal = this.getHebCalByDate(new Date())

        if (hebcal.mevarhim) {
            return true
        }
        return false
    }


//HABBD.ORG
    getZmanimHabad(date = new Date()) {
        const org = this.ORG

        var data = []

        const zmanim = new Zmanim(new Date(date), parseFloat(this.LAT), parseFloat(this.LON))

        var solarCalc = new SolarCalc(new Date(date), parseFloat(this.LAT), parseFloat(this.LON));
        var sun = solarCalc.sun;

        const netshamiti = sun.timeAtAngle(1.583, true)

        const shkiahamiti = sun.timeAtAngle(1.583, false)

        const shaazmanit = (shkiahamiti - netshamiti) / 1000 / 60 / 12

        const hatsotJour = new Date(netshamiti.getTime() + (6 * shaazmanit) * 60000);

        const hatsotNuit = new Date(hatsotJour.getTime() + (12 * 60) * 60000);

        var alotHachahar = sun.timeAtAngle(26.0, true)

        if (isNaN(alotHachahar)) {
            var yesterday = date
            yesterday.setDate(yesterday.getDate() - 1);
            alotHachahar = this.getZmanimHabadHatsotNuit(yesterday)
        }

        data.push({
            nom: "עלות השחר 120 דקות",
            time: alotHachahar
        })

        data.push({
            nom: "עלות השחר 72 דקות",
            time: sun.timeAtAngle(16.9, true)
        })

        data.push({
            nom: "תפילין ושמע",
            time: sun.timeAtAngle(10.2, true)
        })

        data.push({
            nom: "נץ החמה",
            time: zmanim.neitzHaChama()
        })

        data.push({
            nom: "סוף זמן ק״ש",
            time: new Date(netshamiti.getTime() + (3 * shaazmanit) * 60000)
        })

        data.push({
            nom: "סוף זמן תפילה",
            time: new Date(netshamiti.getTime() + (4 * shaazmanit) * 60000)
        })

        data.push({
            nom: "חצות היום",
            time: hatsotJour
        })

        data.push({
            nom: "מנחה גדולה",
            time: new Date(netshamiti.getTime() + (6.5 * shaazmanit) * 60000)
        })

        data.push({
            nom: "מנחה קטנה",
            time: new Date(shkiahamiti.getTime() - (2.5 * shaazmanit) * 60000)
        })

        data.push({
            nom: "פלג המנחה",
            time: new Date(shkiahamiti.getTime() - (1.25 * shaazmanit) * 60000)
        })

        data.push({
            nom: "שקיעת החמה",
            time: sun.timeAtAngle(0.833, false)
        })

        if (org.israel) {
            data.push({
                nom: "צאת הכוכבים",
                time: sun.timeAtAngle(6.83, false)
            })

        } else {
            data.push({
                nom: "צאת הכוכבים",
                time: sun.timeAtAngle(6, false)
            })

            data.push({
                nom: "צאת דאורייתא",
                time: sun.timeAtAngle(6.83, false)
            })
        }


        data.push({
            nom: "חצות לילה",
            time: hatsotNuit
        })


        return data

    }


//HABBD.ORG
    getZmanimHabadHatsotNuit(date) {

        var solarCalc = new SolarCalc(date, parseFloat(this.LAT), parseFloat(this.LON))
        var sun = solarCalc.sun;

        const netshamiti = sun.timeAtAngle(1.583, true)

        const shkiahamiti = sun.timeAtAngle(1.583, false)

        const shaazmanit = (shkiahamiti - netshamiti) / 1000 / 60 / 12

        const hatsotJour = new Date(netshamiti.getTime() + (6 * shaazmanit) * 60000);

        const hatsotNuit = new Date(hatsotJour.getTime() + (12 * 60) * 60000);

        return hatsotNuit

    }

//CALJ
    getZmanimDefault(date = new Date()) {
        var data = []

        const zmanim = new Zmanim(new Date(date), parseFloat(this.LAT), parseFloat(this.LON))

        data.push({
            nom: "עלות השחר",
            time: zmanim.alotHaShachar()
        })

        data.push({
            nom: "תפילין ושמע",
            time: zmanim.misheyakir()
        })

        data.push({
            nom: "נץ החמה",
            time: zmanim.neitzHaChama()
        })

        data.push({
            nom: "סוף זמן ק״ש מ״א",
            time: zmanim.sofZmanShmaMGA()
        })

        data.push({
            nom: "סוף זמן ק״ש גר״א",
            time: zmanim.sofZmanShma()
        })

        data.push({
            nom: "סוף זמן תפילה מ״א",
            time: zmanim.sofZmanTfillaMGA()
        })

        data.push({
            nom: "סוף זמן תפילה גר״א",
            time: zmanim.sofZmanTfilla()
        })

        data.push({
            nom: "חצות היום",
            time: zmanim.chatzot()
        })

        data.push({
            nom: "מנחה גדולה",
            time: zmanim.minchaGedola()
        })

        data.push({
            nom: "מנחה קטנה",
            time: zmanim.minchaKetana()
        })

        data.push({
            nom: "פלג המנחה",
            time: zmanim.plagHaMincha()
        })

        data.push({
            nom: "שקיעת החמה",
            time: zmanim.shkiah()
        })

        data.push({
            nom: "צאת הכוכבים",
            time: zmanim.tzeit(7.083)
        })

        data.push({
            nom: "צאת הכוכבים ר'ת",
            time: zmanim.tzeit(8.5)
        })

        data.push({
            nom: "חצות לילה",
            time: zmanim.chatzotNight()
        })


        return data
    }


    getNextRoshHosdesh(date) {
        var data = []
        var hd = new HDate(date);
        const month = hd.getMonthName()
        var nextMonth = null

        var i = 0
        while (nextMonth == null) {
            hd = hd.add(i)
            //console.log(hd)
            if (month != hd.getMonthName()) {
                nextMonth = hd.getMonthName()
            }
            i++
        }

        for (var h of this.HEBCAL) {
            if (h.roshHodesh && h.roshHodeshMonth == nextMonth) {
                data.push(h)
            }
        }

        return data
    }


    getMolad(month) {

        for (var h of this.HEBCAL) {
            if (h.mevarhim && h.mevarhimMonth == month) {
                return h.molad
            }
        }

        return null
    }


    isChabbat() {
        var date = this.getDateNowFromZman(new Date())

        if (date.getDay() == 6) {
            return true
        }

        return false
    }


    isYomTov() {
        var hebcal = this.getHebCalByDate(new Date())

        if (hebcal.yomtov) {
            return true
        }
        return false
    }

    getAnnivHDate(date) {
        date = this.getDateNowFromZmanV2(date)
        return new HDate(date)
    }
}
